module.exports = __webpack_public_path__ + "static/media/image.6e72c08e.svg";